/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveDevice200Response
 */
export interface RemoveDevice200Response {
    /**
     * 
     * @type {boolean}
     * @memberof RemoveDevice200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RemoveDevice200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the RemoveDevice200Response interface.
 */
export function instanceOfRemoveDevice200Response(value: object): value is RemoveDevice200Response {
    return true;
}

export function RemoveDevice200ResponseFromJSON(json: any): RemoveDevice200Response {
    return RemoveDevice200ResponseFromJSONTyped(json, false);
}

export function RemoveDevice200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveDevice200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function RemoveDevice200ResponseToJSON(json: any): RemoveDevice200Response {
    return RemoveDevice200ResponseToJSONTyped(json, false);
}

export function RemoveDevice200ResponseToJSONTyped(value?: RemoveDevice200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

